import { render, staticRenderFns } from "./AutomationPage.vue?vue&type=template&id=0ce5df13"
import script from "./AutomationPage.vue?vue&type=script&lang=js"
export * from "./AutomationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports